export default __webpack_public_path__ + "static/media/Document.a7902a5f.png";